<template>
  <div>
    <div class="d-flex justify-content-end mb-3">
      <b-button variant="primary" @click="openCreateModal">
        <font-awesome-icon icon="plus" /> Crear Nueva Entrada
      </b-button>
    </div>

    <BlogAdminListNoAuth :refresh-counter="refreshCounter" @edit-post="handleEditPost" @delete-post="handleDeletePost" />

    <b-modal v-model="showFormModal" :title="editingPost ? 'Editar Entrada' : 'Crear Nueva Entrada'" class="custom-blog-modal" @hidden="handleModalHidden" no-close-on-backdrop no-fade>
      <template #default>
        <div v-if="availableImages.length > 0">
          <BlogAdminFormNoAuth
            :post-to-edit="editingPost"
            :available-images="availableImages"
            @post-saved="handlePostSaved"
            @cancel-edit="handleCancelEdit"
          />
        </div>
        <div v-else>Cargando imágenes...</div>
      </template>
      <template #footer>
        <!-- El formulario maneja sus propios botones de guardar/cancelar -->
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { BButton, BModal } from 'bootstrap-vue-next'; // Importar BButton y BModal
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'; // Importar FontAwesomeIcon
import BlogAdminListNoAuth from './BlogAdminListNoAuth.vue';
import BlogAdminFormNoAuth from './BlogAdminFormNoAuth.vue';
import { listImages } from '../../../services/imageService.js';
import { deleteBlogPost } from '../../../services/blogService.js';

export default {
  components: {
    BlogAdminListNoAuth,
    BlogAdminFormNoAuth,
    BButton, // Registrar BButton
    BModal,  // Registrar BModal
    FontAwesomeIcon, // Registrar FontAwesomeIcon
  },
  setup() {
    const editingPost = ref(null);
    const availableImages = ref([]);
    const refreshCounter = ref(0);
    const showFormModal = ref(false); // Controla la visibilidad del modal

    const openCreateModal = () => {
      editingPost.value = null; // Asegurarse de que es un formulario de creación
      showFormModal.value = true;
    };

    const handleEditPost = (postData) => {
      editingPost.value = postData;
      showFormModal.value = true; // Abrir modal para edición
    };

    const handleDeletePost = async (postId, postTitle) => {
        if (confirm(`¿Estás seguro de que quieres eliminar la entrada "${postTitle}"?`)) {
            try {
                const token = localStorage.getItem('jwt_token');
                await deleteBlogPost(postId, token); // Pasar el token JWT
                alert(`Entrada "${postTitle}" eliminada con éxito.`);
                refreshCounter.value++; // Incrementar para recargar la lista
            } catch (err) {
                console.error(`Error al eliminar post ${postId}:`, err);
                alert(`Error al eliminar entrada "${postTitle}": ${err.message}`);
            }
        }
    };

    const handlePostSaved = () => {
      showFormModal.value = false; // Cerrar el modal
      editingPost.value = null; // Resetear el post en edición
      refreshCounter.value++; // Incrementar para recargar la lista
    };

    const handleCancelEdit = () => {
      showFormModal.value = false; // Cerrar el modal
      editingPost.value = null; // Resetear el post en edición
    };

    const handleModalHidden = () => {
      editingPost.value = null; // Asegurarse de resetear editingPost cuando el modal se cierra por cualquier medio
    };

    // Función para cargar las imágenes
    const fetchImages = async () => {
      try {
        const token = localStorage.getItem('jwt_token');
        availableImages.value = await listImages(token); // Pasar el token JWT
      } catch (error) {
        console.error("Error al cargar imágenes:", error);
        // Manejar el error, quizás mostrar un mensaje al usuario
      }
    };

    // Cargar imágenes al montar el componente
    onMounted(() => {
      fetchImages();
    });

    const reactiveAvailableImages = computed(() => availableImages.value); // Propiedad computada

    return {
      editingPost,
      availableImages: reactiveAvailableImages,
      refreshCounter,
      showFormModal, // Exponer showFormModal
      openCreateModal, // Exponer la función para abrir el modal de creación
      handleEditPost,
      handlePostSaved, // Exponer el manejador de guardado
      handleCancelEdit, // Exponer el manejador de cancelación
      handleDeletePost,
      handleModalHidden, // Exponer el manejador de cierre de modal
    };
  },
};
</script>

<style>
/* Estilos específicos para BlogAdminPage */
.custom-blog-modal .modal-dialog {
  max-width: 95% !important; /* Ajusta este valor según sea necesario */
}
</style>